(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search-banner"]) return;
  try {
    
  const term = document.querySelector('.search-hero__term');

  if (term) {
    const originalQ = new URLSearchParams(location.search).get('original_q');
    const catchall = term.dataset.catchall;

    if (originalQ && catchall) {
      term.textContent = term.textContent.replaceAll(catchall, originalQ);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
